import { render } from "./nick.vue?vue&type=template&id=37b817ed&ts=true"
import script from "./nick.vue?vue&type=script&lang=ts"
export * from "./nick.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Users\\orson\\coding\\thelounge\\thelounge\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"client/components/MessageTypes/nick.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "37b817ed"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('37b817ed', __exports__)) {
    api.reload('37b817ed', __exports__)
  }
  
  module.hot.accept("./nick.vue?vue&type=template&id=37b817ed&ts=true", () => {
    api.rerender('37b817ed', render)
  })

}


export default __exports__